import React from "react";


export default function Checkbox(props) {
  return <input className="ds-checkbox" type="checkbox" checked={props.checked} onChange={props.onchange}/>
}


/*

Usage:

<Checkbox onchange={} />

- onchange (Optional): function

*/
